import * as types from './action-types';
import axios from 'axios';
import { apiATC } from '../config';

const metalEndpoint = `${apiATC}/metal/metal.php`;

const logError = error => console.error(error);

export const fetchComptePoidsBalances = (clientId = null, dateDebut = null, dateFin = null) => async (dispatch) => {
  dispatch({ type: types.COMPTE_POIDS_LOAD_REQUEST });
  try {
    const params = { action: 'compte_poids_balances' };
    
    if (clientId) params.clientId = clientId;
    if (dateDebut) params.dateDebut = dateDebut;
    if (dateFin) params.dateFin = dateFin;
    
    const res = await axios.get(metalEndpoint, { params });
    const result = res.data || { items: [], totalSolde750: 0 };
    dispatch({ type: types.COMPTE_POIDS_LOAD_SUCCESS, payload: result });
    return result;
  } catch (error) {
    logError(error);
    dispatch({ type: types.COMPTE_POIDS_LOAD_FAILURE, error: error?.response?.data?.error || 'Erreur de chargement' });
    throw error;
  }
};

export const setComptePoidsFilter = (clientId) => ({
  type: types.COMPTE_POIDS_SET_FILTER,
  payload: clientId || null
});

export const setComptePoidsDates = (dateDebut, dateFin) => ({
  type: types.COMPTE_POIDS_SET_DATE_RANGE,
  payload: { dateDebut, dateFin }
});

export const clearComptePoidsError = () => ({ type: types.COMPTE_POIDS_CLEAR_ERROR });

export const fetchComptePoidsOperations = (clientId) => async () => {
  try {
    const params = { action: 'compte_poids_operations' };
    if (clientId) params.clientId = clientId;
    const res = await axios.get(metalEndpoint, { params });
    return res.data?.data || [];
  } catch (error) {
    logError(error);
    throw error;
  }
};

export const createEntreeBroutille = ({ clientId, clientName, description, poids750, perte, dateSaisie, poids_brut, taux_perte }) => async (dispatch, getState) => {
  dispatch({ type: types.COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_REQUEST });
  try {
    const payload = { clientId, description, poids750, perte: perte || 0, dateSaisie: dateSaisie || new Date().toISOString().split('T')[0], poids_brut, taux_perte };
    await axios.post(`${metalEndpoint}?action=compte_poids_entree_broutille`, payload);
    const { filterClientId, dateDebut, dateFin } = getState().comptePoids || {};
    const result = await dispatch(fetchComptePoidsBalances(filterClientId || null, dateDebut, dateFin));
    dispatch({ type: types.COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_SUCCESS, payload: result });
    return { success: true };
  } catch (error) {
    logError(error);
    const errMsg = error?.response?.data?.errors?.[0] || error?.response?.data?.error || 'Erreur création entrée broutille';
    dispatch({ type: types.COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_FAILURE, error: errMsg });
    throw error;
  }
};

export const createRetourAvoir = ({ clientId, clientName, description, poids750, dateSaisie }) => async (dispatch, getState) => {
  dispatch({ type: types.COMPTE_POIDS_CREATE_RETOUR_AVOIR_REQUEST });
  try {
    const payload = { clientId, description, poids750, dateSaisie: dateSaisie || new Date().toISOString().split('T')[0] };
    await axios.post(`${metalEndpoint}?action=compte_poids_retour_avoir`, payload);
    const { filterClientId, dateDebut, dateFin } = getState().comptePoids || {};
    const result = await dispatch(fetchComptePoidsBalances(filterClientId || null, dateDebut, dateFin));
    dispatch({ type: types.COMPTE_POIDS_CREATE_RETOUR_AVOIR_SUCCESS, payload: result });
    return { success: true };
  } catch (error) {
    logError(error);
    const errMsg = error?.response?.data?.errors?.[0] || error?.response?.data?.error || 'Erreur création retour avoir';
    dispatch({ type: types.COMPTE_POIDS_CREATE_RETOUR_AVOIR_FAILURE, error: errMsg });
    throw error;
  }
};
